import React from 'react';
import Parallax from 'parallax-js';
import UAParser from 'ua-parser-js';
import Mouse from '../../components/Mouse';
import send from '../../utils';

import './lib-block.css';

const uaParser = new UAParser();
const browser = uaParser.getResult();

class LibBlock extends React.PureComponent {
  componentDidMount() {
    new Parallax(this.block);
  }

  render() {
    const isWebkit = browser.browser.name === 'WebKit';

    return (
      <div className={`block lib ${isWebkit && 'webkit'}`}>
        <div className="cloud-block" ref={(block) => { this.block = block; }}>
          <div data-depth="0.20"><div className="cloud left" /></div>
          <div data-depth="0.30"><div className="cloud right" /></div>
        </div>
        <div className="head left" />
        <div className="head right" />
        <div className="container">
          <div className="knowledge-block">
            <div className="logo" />
            <h2 className="title">止痛藥知識庫</h2>
            <div className="knowledge effect">
              <div className="cover" />
              <div className="text">
                <a target="_blank" onClick={() => send('Button', 'Click', 'Btn_know1')} rel="noopener noreferrer" href="http://www.pain-expert.com.tw/qna/%e6%ad%a2%e7%97%9b%e8%97%a5%e5%a6%82%e4%bd%95%e5%9c%a8%e8%85%8e%e8%87%9f%e4%bd%9c%e7%94%a8%ef%bc%9f/">
                止痛藥<br />
                如何在腎臟作用？
                </a>
              </div>
            </div>
            <div className="knowledge kidney">
              <div className="cover" />
              <div className="text">
                <a target="_blank" onClick={() => send('Button', 'Click', 'Btn_know2')} rel="noopener noreferrer" href="http://www.pain-expert.com.tw/qna/%e6%ad%a2%e7%97%9b%e6%ad%a2%e7%97%9b%e8%97%a5%e6%9c%83%e4%b8%8d%e6%9c%83%e5%82%b7%e8%85%8e%ef%bc%9f%e8%97%a5%e6%9c%83%e4%b8%8d%e6%9c%83%e5%82%b7%e8%85%8e%ef%bc%9f/">
                止痛藥<br />
                會不會傷腎？
                </a>
              </div>
            </div>
            <div className="knowledge liver">
              <div className="cover" />
              <div className="text">
                <a target="_blank" onClick={() => send('Button', 'Click', 'Btn_know3')} rel="noopener noreferrer" href="http://www.pain-expert.com.tw/qna/%e6%ad%a2%e7%97%9b%e8%97%a5%e5%a6%82%e4%bd%95%e5%9c%a8%e8%82%9d%e8%87%9f%e4%bd%9c%e7%94%a8%ef%bc%9f/">
                止痛藥<br />
                如何在肝臟作用？
                </a>
              </div>
            </div>
            <div className="knowledge addictive">
              <div className="cover" />
              <div className="text">
                <a target="_blank" onClick={() => send('Button', 'Click', 'Btn_know4')} rel="noopener noreferrer" href="http://www.pain-expert.com.tw/qna/%e6%ad%a2%e7%97%9b%e8%97%a5%e6%9c%83%e4%b8%8a%e7%99%ae%e3%80%81%e4%be%9d%e8%b3%b4%e6%88%90%e6%80%a7%e5%97%8e%ef%bc%9f/">
                止痛藥<br />
                會上癮、依賴成性？
                </a>
              </div>
            </div>
            <div className="knowledge stomach-pain">
              <div className="cover" />
              <div className="text">
                <a target="_blank" onClick={() => send('Button', 'Click', 'Btn_know5')} rel="noopener noreferrer" href="http://www.pain-expert.com.tw/qna/%e7%82%ba%e4%bd%95%e5%90%83%e6%ad%a2%e7%97%9b%e8%97%a5%e8%83%83%e6%9c%83%e7%97%9b%ef%bc%9f/">
                為何<br />
                吃止痛藥胃會痛？
                </a>
              </div>
            </div>
            <div className="knowledge residual">
              <div className="cover" />
              <div className="text">
                <a target="_blank" onClick={() => send('Button', 'Click', 'Btn_know6')} rel="noopener noreferrer" href="http://www.pain-expert.com.tw/authors/%E8%94%A1%E7%B6%AD%E7%A6%8E/%E8%AA%8D%E8%AD%98%E8%97%A5%E7%89%A9%E6%AE%98%E7%95%99/">
                止痛藥究竟 <br />
                會不會殘留體內？
                </a>
              </div>
            </div>
          </div>
        </div>
        <footer className={`${isWebkit && 'is-webkit'}`}>
          <a onClick={() => send('Button', 'Click', 'Btn_pain')} href="http://www.pain-expert.com.tw/" target="_blank" rel="noopener noreferrer">
            <div className="img" />
          </a>
          <span className="text">
            © 2017 疼痛知識家. 版權所有請勿轉載
            <div>CHTW/CHPAN/0097/17</div>
          </span>
        </footer>
        <a href="#sectionTwo"  data-anchor="sectionTwo">
          <Mouse up className="hide" />
        </a>
        <a href="#sectionOne"  data-anchor="sectionOne">
          <div className="go-top" />
        </a>
      </div>
    );
  }
}

export default LibBlock;



// WEBPACK FOOTER //
// ./src/blocks/LibBlock/index.js